
import { Component, Vue } from "vue-property-decorator";
import * as Models from "@gigalot/data-models";
import { formatDoseLabel as formatDoseLabelHelper } from "../../helpers/doses";

@Component
export default class TreatmentData extends Vue {
  treatments: Models.Treatment[] = [];
  searchTerm: string = "";
  detailsDialog: boolean = false;
  details: Models.Treatment | null = null;

  created() {
    this.$store.commit("navFuncs", {
      save: undefined,
      back: () => {
        this.$router.go(-1);
      },
    });
    this.loadTreatments();
  }

  async loadTreatments() {
    this.treatments = await this.$store.dispatch("data/getTreatments");
  }

  get filteredTreatments(): Models.Treatment[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) return this.treatments;
    return this.treatments.filter((t) => (t.description || "").toLowerCase().includes(term));
  }

  doseKey(dose: Models.Dose, idx: number): string | number {
    return (dose.item && dose.item.description) || idx;
  }

  doseDescription(dose: Models.Dose, idx: number): string {
    return (dose.item && dose.item.description) || `Dose ${idx + 1}`;
  }

  openTreatmentDetails(treatment: Models.Treatment) {
    this.details = treatment;
    this.detailsDialog = true;
  }

  closeTreatmentDetails() {
    this.detailsDialog = false;
    this.details = null;
  }

  formatDoseLabel(dose: Models.Dose): string {
    return formatDoseLabelHelper(dose);
  }
}
